// extracted by mini-css-extract-plugin
export default {"container":"NoResults_container__pAmBq","title":"NoResults_title__6aUB0","description":"NoResults_description__qaHbt","buttons":"NoResults_buttons__oxZjK"};